import { render, staticRenderFns } from "./ClientWindowView.vue?vue&type=template&id=af6f5fb6&scoped=true&"
import script from "./ClientWindowView.vue?vue&type=script&lang=js&"
export * from "./ClientWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f5fb6",
  null
  
)

export default component.exports